
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';

  @Component({
    components: {},
  })
  export default class DlgHostSelector extends Vue {
    @Prop({type: Boolean, default: false}) private loading!: boolean;
    @Prop({type: Array, default: () => []}) private existingHosts!: any;

    @Action('admin/hosts/read') private read!: any;

    @Getter('admin/hosts/all') private all!: any;

    private search: string = '';
    private headers: any = [
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
        width: '50px',
      },
      {
        text: 'Name',
        align: 'left',
        value: 'surname',
      },
      {
        text: 'Email',
        align: 'left',
        value: 'email',
      },
    ];
    private dialog: boolean = false;
    private localHosts: any = [];

    public close() {
      this.dialog = false;
    }

    private async mounted() {
      if (!this.all || this.all.length === 0) {
        await this.read();
      }
    }

    private addList(host) {
      this.$emit('selected', host);
    }

    @Watch('dialog')
    private dialogChanged() {
      if (this.dialog) {
        const ids = this.existingHosts.map((el) => el.id);
        this.localHosts = this.all.filter((host) => ids.indexOf(host.id) === -1);
      }
    }
  }
